import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/modules/auth';
import academico from '@/modules/academico';
import banner from '@/modules/banner';
import sedes from '@/modules/sedes';
import tipoDocumento from '@/modules/tipoDocumento';
import estadoCivil from '@/modules/estadoCivil';
import regimenSalud from '@/modules/regimenSalud';
import nivelFormacion from '@/modules/nivelFormacion';
import ocupacion from '@/modules/ocupacion';
import grupoEtnico from '@/modules/grupoEtnico';
import student from '@/modules/student';
import discapacidad from '@/modules/discapacidad';
import ciudad from '@/modules/ciudad';
import tutoria from '@/modules/tutoria';
import notificaciones from '@/modules/notificaciones';
import encuestaSatisfaccion from '@/modules/encuestaSatisfaccion';

import router from './router'
import {version} from '../package.json';

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    processing: false,
    warning: null,
    error: null,
    show_modal_error: false,
    modal_error:null,
    packageVersion : version,
    show_notification: true,
    isDebug: false,
    baseUrl: process.env.BASE_URL,
    nodeEnv: process.env.NODE_ENV,
    appInstance: process.env.VUE_APP_INSTANCE,
    enable:null
  },
  getters:{

  },
  mutations: {
    startProcessing (state) {
      state.processing = true;
    },
    setDebug (state, value) {
      state.isDebug = value;
    },
    stopProcessing (state) {
      state.processing = false;
    },
    setError (state, responseApi) {
      if(responseApi.data){
        let data = responseApi.data
        let data_error = data && data.error && data.error.message ? data.error : data
        if(data_error){
          if(data_error.message){
            if(data_error.name && data_error.name=='InvalidJwtToken'){
              state.error = 'Verificación de identidad. Por favor cierre la aplicación e intente nuevamente.';
              this.dispatch('auth/logout')
              router.push('/')
            }else{
              state.error = data_error.message;  
            }
          }else{
            if (data_error.error) {
              state.error = data_error.error;
            } else {
              state.error = data_error;
            }
          }  
        }else{
          if (data.error) {
            state.error = data.error;
          } else {
            state.error = data;
          }
        }
      }else{
        if(responseApi.ok==false){
          state.error = 'Verifique su conexión a internet.';
          if (responseApi && responseApi.url.indexOf('sandbox')) {
            state.error = "Si eres estudiante y estás teniendo problemas con tu programador, asegúrate de ingresar al link correcto <a href='https://blocks.asw.edu.co'>https://blocks.asw.edu.co</a>"
          }
        } else {
          state.error = responseApi;
        }
        console.log(responseApi)
      }
      
      setTimeout(() => {
        state.error = null
      },5000)
    },
    reiniciarModalError(state) {
      state.modal_error = null
      state.show_modal_error = false
    },
    setErrorModal (state, responseApi) {
      if(responseApi.data){
        let data = responseApi.data
        let data_error = data && data.error && data.error.message ? data.error : data
        if(data_error){
          if(data_error.message){
            if(data_error.name && data_error.name=='InvalidJwtToken'){
              state.error = 'Verificación de identidad. Por favor cierre la aplicación e intente nuevamente.';
              setTimeout(() => {
                state.error = null
              },5000)
              this.dispatch('auth/logout')
              router.push('/')
            }else{
              state.modal_error = data_error.message;  
              state.show_modal_error = true;
            }
          }else{
            if (data_error.error) {
              state.modal_error = data_error.error;
              state.show_modal_error = true;
            } else {
              state.modal_error = data_error;
              state.show_modal_error = true;
            }
          }  
        }else{
          if (data.error) {
            state.modal_error = data.error;
            state.show_modal_error = true;
          } else {
            state.modal_error = data;
            state.show_modal_error = true;
          }
        }
      }else{
        if(responseApi.ok==false){
          state.modal_error = 'Verifique su conexión a internet.';
          state.show_modal_error = true;
        } else {
          state.modal_error = responseApi;
          state.show_modal_error = true;
        }
        console.log(responseApi)
      }
    },
    setWarning (state, value) {
      state.warning = value
      return new Promise((resolve) => {
        setTimeout(function () {
          state.warning = null
          resolve()
        }, 5000)
      })
    },
    setShowNotification:  (state, value) => {
      state.show_notification = value
    },
    setEnable: (state, value) => {
      state.enable = value
    }
  },
  actions: {
    fetchEnable: ({commit}) => {
      return new Promise((resolve, reject) => {
        Vue.http.get('enable')
          .then(response => {
              commit('setEnable',response.data);
              resolve(response.data);
          })
          .catch(response => {
            reject(response);
          })
          .finally(() => {})
      })
    }
  },
  modules: {
    auth,
    academico,
    banner,
    sedes,
    tipoDocumento,
    estadoCivil,
    regimenSalud,
    nivelFormacion,
    ocupacion,
    grupoEtnico,
    discapacidad,
    student,
    ciudad,
    tutoria,
    notificaciones,
    encuestaSatisfaccion
  }
})


export default store;
